import { Component, Inject, Injector, Input, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';
import { Attendance, ButtonZapiComponent, Channel, PreviewMediaComponent, PreviewMediaData, ResponseTypeEnum, UtilHelper } from '../../../../public-api';
import { AbstractComponent } from '../../../commons/abstract.component';
import { Pager } from '../../../commons/pager';
import { Category } from '../../../models/category.model';
import { ChannelTypeEnum } from '../../../models/enum/channel.type';
import { Response } from '../../../models/response.model';
import { CategoryService } from '../../../services/category.service';
import { ResponseService } from '../../../services/response.service';

export interface ModalResponseFastData {
  channeltype: Channel;
  attendance?: Attendance;
  channel?: Channel;
}

@Component({
    selector: 'app-modal-response-fast',
    // templateUrl: './modal-response-fast.component.html',
    templateUrl: './modal-response-fast.v2.component.html',
    styleUrls: ['./modal-response-fast.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalResponseFastComponent extends AbstractComponent {
  listCategory: Category[] = [];

  pager: Pager<Response> = new Pager<Response>({ perPage: 7 });

  loadingSpinnerSubject = new BehaviorSubject<boolean>(true);
  loadingSpinner$ = this.loadingSpinnerSubject.asObservable();

  isTableResponseApp: boolean;
  @Input() previewOnly: boolean = false;

  constructor(
    injector: Injector,
    @Inject(MAT_DIALOG_DATA) public data: ModalResponseFastData,
    private _matDialogRef: MatDialogRef<ModalResponseFastComponent>,
    private categoryService: CategoryService,
    private responseService: ResponseService,
    private modalPreview: MatDialog,
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.getList(this.searchString);
    this.getListCategory();
  }

  search(term: string): void {
    this.searchString = term;
    this.pager.page = 1;
    this.getList(term);
  }

  selectedResponseFast(response: Response): void {
    if (response.midia) {
      const dialogRefPreview = this.modalPreview.open(PreviewMediaComponent, {
        width: '600px',
        data: <PreviewMediaData>{
          response,
          midia: response.midia,
          message: response.message,
          isTableResponseApp: true
        }
      });

      dialogRefPreview.afterClosed().subscribe((result: PreviewMediaData) => {
        if (result) {
          this._matDialogRef.close(result);
        }
      });
    } else if (Array.isArray(response?.buttonActions) && response?.buttonActions?.length > 0) {
      // RCS does not support buttons at all (RF-10)
      if ((this.data?.channeltype?.type ?? this.data?.channel?.type) === ChannelTypeEnum.RCS_API) {
        this.alertService.error(this.t('attendance.chat.rcsButtonsNotSupported'));
        return;
      }

      const dialogRefPreview = this.modalPreview.open(ButtonZapiComponent, {
        width: '600px',
        data: {
          buttonActionsArray: response?.buttonActions,
          maxButtons: Array.isArray(response?.buttonActions) ? response?.buttonActions.length : 0,
          title: response.title || response?.title,
          message: response.message || response.message,
          footer: response.footer || response?.footer,
          showFullMessage: true,
          previewOnly: true,
          showConfirmButton: true,
        }
      });

      dialogRefPreview.afterClosed().subscribe((result) => {
        if (result) {
          this._matDialogRef.close(response);
        }
      });
    } else {
      this._matDialogRef.close(response);
    }
  }

  selectedCategory(category: string): void {
    this.getList(category);
  }

  loadPage(page: number) {
    this.pager.page = page;
    this.getList(this.searchString);
  }

  getList(termSearch: string): void {
    this.loadingSpinnerSubject.next(true);

    this.searchParams = {
      company: this.getIDCurrentCompany(),
      type: ResponseTypeEnum.QUICK,
      channelType: this.data?.channeltype?.type
    };

    this.responseService.getAll(this.pager.page, this.pager.perPage, termSearch, this.searchParams).subscribe({
      next: (value: Pager<Response>) => {
        if (this.previewOnly) {
          const withButtons = value.list.filter(
            item => Array.isArray(item?.buttonActions) && item?.buttonActions?.length > 0
          );

          this.pager = {
            ...value,
            list: withButtons,
            total: withButtons.length,
          };

        } else {
          this.pager = value;
        }

      },
      complete: () => this.loadingSpinnerSubject.next(false),
    });

 }   

  private getListCategory(): void {
    this.categoryService.getList().subscribe({
      next: (value) => {
        this.listCategory = value;
      },
    });
  }

  public getFileExtension(item: Response): string {
    if (item.buttonActions?.length > 0) {
      return this.t('shared.modalResponseFast.fileTypeButtons')
    }
    if (item.vcardContact) {
      return this.t('shared.modalResponseFast.fileTypeContact');
    }
    if (item.place) {
      return this.t('shared.modalResponseFast.fileTypeLocation');
    }
    return UtilHelper.getFileExtension(item.contentType);
  }

}